import styled from "styled-components";

// TEXT

// STYLES
export const CircularSvg = styled.svg`
  border-radius: 50%;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
